/** Gestion de l'installation : capture de `beforeinstallprompt` et détection iOS. */
import { create } from 'zustand';

interface BeforeInstallPromptEvent extends Event {
  prompt(): Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}

interface InstallState {
  deferred: BeforeInstallPromptEvent | null;
  installed: boolean;
  promptInstall(): Promise<'accepted' | 'dismissed' | 'unavailable'>;
}

export const isStandalone = () =>
  typeof window !== 'undefined' && (window.matchMedia('(display-mode: standalone)').matches || (navigator as Navigator & { standalone?: boolean }).standalone === true);

export const isIos = () => typeof navigator !== 'undefined' && /iphone|ipad|ipod/i.test(navigator.userAgent) && !/crios|fxios/i.test(navigator.userAgent);

export const useInstallStore = create<InstallState>((set, get) => ({
  deferred: null,
  installed: isStandalone(),
  async promptInstall() {
    const deferred = get().deferred;
    if (!deferred) return 'unavailable';
    await deferred.prompt();
    const { outcome } = await deferred.userChoice;
    set({ deferred: null, installed: outcome === 'accepted' });
    return outcome;
  },
}));

export function listenForInstallPrompt(): void {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    useInstallStore.setState({ deferred: e as BeforeInstallPromptEvent });
  });
  window.addEventListener('appinstalled', () => useInstallStore.setState({ installed: true, deferred: null }));
}
